(() => {
	const navigationParagraphs = document.querySelectorAll('.navigation-paragraph');

	navigationParagraphs.forEach(paragraph => {
		const navCollapseBtn = paragraph.querySelector('.navigation-paragraph__collapse');
		const navMenu = paragraph.querySelector('.navigation');
		document.fonts.ready.then(function () {
			navMenu.style.maxHeight = navMenu.scrollHeight + 'px';
		});
		
		if(navCollapseBtn) {
			navCollapseBtn.addEventListener('click', () => {
				if(paragraph.classList.contains('navigation-paragraph--opened')) {
					paragraph.classList.remove('navigation-paragraph--opened');
					navMenu.style.maxHeight = '0';
				} else {
					paragraph.classList.add('navigation-paragraph--opened');
					navMenu.style.maxHeight = navMenu.scrollHeight + 'px';
				}
			});
		}
	});

})();
